/**
 * PdfPreviewSwitcher — three buttons that download the three P2 PDFs.
 * `Full` is admin/coordinator-only (relies on `careplans.export`),
 * `Staff Brief` is also admin/coordinator, `Plain-language` likewise
 * — internal-notes redaction is enforced server-side regardless.
 */
import React from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { FileText, Smartphone, BookOpen } from 'lucide-react';
import { toast } from 'sonner';

async function downloadBlob(url, filename) {
  try {
    const res = await api.get(url, { responseType: 'blob' });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
  } catch (e) {
    toast.error(e?.response?.data?.error?.message || 'PDF download failed');
  }
}

export function PdfPreviewSwitcher({ planId }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid={`structured-pdf-switcher-${planId}`}>
      <Button size="sm" variant="outline"
              onClick={() => downloadBlob(`/careplans/${planId}/export-pdf/full-structured`,
                                          `careplan-${planId}-full.pdf`)}
              data-testid="pdf-full">
        <FileText className="h-3 w-3 mr-1" /> Full PDF
      </Button>
      <Button size="sm" variant="outline"
              onClick={() => downloadBlob(`/careplans/${planId}/export-pdf/staff-brief`,
                                          `careplan-${planId}-staff-brief.pdf`)}
              data-testid="pdf-staff-brief">
        <Smartphone className="h-3 w-3 mr-1" /> Staff Brief PDF
      </Button>
      <Button size="sm" variant="outline"
              onClick={() => downloadBlob(`/careplans/${planId}/export-pdf/plain-language`,
                                          `careplan-${planId}-plain.pdf`)}
              data-testid="pdf-plain-language">
        <BookOpen className="h-3 w-3 mr-1" /> Plain-language PDF
      </Button>
    </div>
  );
}

export default PdfPreviewSwitcher;
